import React from 'react';

import { cn } from 'lib/helpers/utility';

import Typography from 'components/shared/Typography/Typography';

const SignaturePreview = ({
  value,
  label,
  canvasHeight,
  note,
  emptyText,
  className,
  'data-qa': dataQa = ''
}) => (
  <div className={cn('flex min-w-0 flex-col gap-3', className)}>
    <Typography variant="label" size="medium" weight="medium" color="neutral-800">
      {label}
    </Typography>
    <div
      style={{ height: canvasHeight }}
      className="flex w-full items-center justify-center overflow-hidden rounded-md border border-solid border-neutral-200 bg-neutral-25">
      {value ? (
        <img
          src={value}
          alt={label}
          data-qa={dataQa}
          className="max-h-full max-w-full object-contain"
        />
      ) : (
        <span className="text-sm text-neutral-500">{emptyText}</span>
      )}
    </div>
    {note && <p className="text-xs text-neutral-500">{note}</p>}
  </div>
);

export default SignaturePreview;
